import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeHighlight from "rehype-highlight";
import 'highlight.js/styles/github-dark.css';

export default function Markdown({ content }) {
    return (
        <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            rehypePlugins={[rehypeHighlight]}
            components={{
                p: ({ children }) => <p style={{ margin: "8px 0" }}>{children}</p>,

                code({ inline, className, children, ...props }) {
                    return !inline ? (
                        <pre className="code-block">
                            <code className={className} {...props}>
                                {children}
                            </code>
                        </pre>
                    ) : (
                        <code className="inline-code">{children}</code>
                    );
                },

                a: ({ href, children }) => (
                    <a href={href} target="_blank" rel="noreferrer">
                        {children}
                    </a>
                )
            }}
        >
            {content}
        </ReactMarkdown>
    );
}